import { createSelector } from 'reselect';

const getGeneralInformationReady = state => state.users.generalInformationReady;
const getExpressConfigurationReady = state => state.users.expressConfigurationReady;
const getIsCreating = state => state.users.isCreating;
const getTotalUsers = state => state.users.totalUsers;
const getIsFetching = state => state.users.isFetching;
const getError = state => state.users.error;
const getTelephonyProfiles = state => state.users.TelephonyProfiles;
const getEdition = state => state.users.edition;

export const getSearchText = state => state.users.searchText;

export const getUsers = state => state.users.users;

export const getGeneralInformation = state => state.users.generalInformation;

export const getExpressConfiguration = state => state.users.expressConfiguration;

export const generalInformationReadySelector = createSelector(
    getGeneralInformationReady,
    generalInformationReady => generalInformationReady
);

export const expressConfigurationReadySelector = createSelector(
    getExpressConfigurationReady,
    expressConfigurationReady => expressConfigurationReady
);

export const canCreateSelector = createSelector(
    getGeneralInformationReady,
    getExpressConfigurationReady,
    (generalInformationReady, expressConfigurationReady) => generalInformationReady && expressConfigurationReady
);

export const isCreatingSelector = createSelector(
    getIsCreating,
    isCreating => isCreating
);

export const usersSelector = createSelector(
    getUsers,
    users => users
);

export const totalUsersSelector = createSelector(
    getTotalUsers,
    totalUsers => totalUsers
);

export const visibleUsersSelector = createSelector(
    getUsers,
    users => users.length
);

export const isFetchingSelector = createSelector(
    getIsFetching,
    isFetching => isFetching
);

export const errorSelector = createSelector(
    getError,
    error => error
);

export const telephonyProfilesSelector = createSelector(
    getTelephonyProfiles,
    TelephonyProfiles => TelephonyProfiles
);

export const editionSelector = createSelector(
    getEdition,
    edition => edition
);

export const searchTextSelector = createSelector(
    getSearchText,
    searchText => searchText
);
